import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function activeStatusBadgeClass(isActive: boolean) {
  return isActive
    ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
    : "bg-gray-500/10 text-gray-600 dark:text-gray-400";
}
